module.exports = __webpack_public_path__ + "img/Help.170d00c8.svg";